export const navigationUtil = {
	navigateToUrl(url: string, target: '_self' | '_blank' = '_self'): void {
		if (!url) return

		if (target === '_blank') {
			window.open(url, '_blank', 'noopener,noreferrer')
		} else {
			window.location.href = url
		}
	},
}

export function navigateToUrl(url: string, target: '_self' | '_blank' = '_self'): void {
	navigationUtil.navigateToUrl(url, target)
}
